import { useEffect, useState } from "react";

export function ReadingProgress() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const update = () => {
      const doc = document.documentElement;
      const max = doc.scrollHeight - window.innerHeight;
      setProgress(max > 0 ? Math.min(100, (window.scrollY / max) * 100) : 0);
    };
    update();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    return () => {
      window.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
    };
  }, []);

  return (
    <div className="fixed left-0 top-0 z-50 h-1 w-full bg-transparent" role="progressbar" aria-valuenow={Math.round(progress)} aria-valuemin={0} aria-valuemax={100} data-testid="reading-progress">
      <div className="h-full overflow-hidden" style={{ width: `${progress}%`, transition: "width 80ms linear" }} data-testid="reading-progress-fill">
        <div className="tricolor-bar h-full w-screen shadow-[0_1px_4px_rgba(28,25,23,0.15)]" />
      </div>
    </div>
  );
}
